import { useState } from "react";
import IconFilter from "@/app/(components)/generics/Icons/IconFilter";
import Popover from "@/app/(components)/generics/Popover/Popover";
import PopoverContent from "@/app/(components)/generics/Popover/PopoverContent";
import PopoverTrigger from "@/app/(components)/generics/Popover/PopoverTrigger";
import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";
import { ProjectMemberData } from "@/app/types/project/ProjectMember";
import { UStyles } from "@/app/utils/UStyles";
import styles from "./MemberFilter.module.css";

type Props = {
  members: ProjectMemberData[];
  value: number | null | undefined;
  onChange: (memberId: number | null | undefined) => void;
  lang: string;
  currentUserId?: number | null;
};

export default function MemberFilter(props: Props) {
  const T = useT();
  const { members, value, onChange, currentUserId } = props;
  const [isOpen, setIsOpen] = useState(false);

  const handleSelect = (memberId: number | null | undefined) => {
    onChange(memberId);
    setIsOpen(false);
  };

  const currentUserMember = currentUserId
    ? members.find((m) => m.userId === currentUserId)
    : undefined;
  const otherMembers = currentUserMember
    ? members.filter((m) => m.id !== currentUserMember.id)
    : members;

  return (
    <Popover
      isVisible={isOpen}
      setIsVisible={setIsOpen}
      openAfterClick={true}
      closeWhenClickOutside={true}
      isPortaled={true}
    >
      <PopoverTrigger>
        <span className={UStyles.classNames(styles.trigger, value !== undefined && styles.active)}>
          <IconFilter size={13} />
        </span>
      </PopoverTrigger>

      <PopoverContent position={{ default: { top: "8px", right: "0px" } }}>
        <div className={styles.popoverContent}>
          <div className={styles.list}>
            <div
              className={UStyles.classNames(styles.item, value === undefined && styles.itemActive)}
              onClick={() => handleSelect(undefined)}
            >
              {T(TKey.PROJECT_MEMBER_FILTER_ALL)}
            </div>
            <div
              className={UStyles.classNames(styles.item, value === null && styles.itemActive)}
              onClick={() => handleSelect(null)}
            >
              {T(TKey.PROJECT_MEMBER_UNASSIGNED)}
            </div>
            {currentUserMember && (
              <div
                className={UStyles.classNames(
                  styles.item,
                  styles.itemMe,
                  value === currentUserMember.id && styles.itemActive,
                )}
                onClick={() => handleSelect(currentUserMember.id)}
              >
                {T(TKey.PROJECT_MEMBER_FILTER_ME)}
              </div>
            )}
            {otherMembers.map((member) => (
              <div
                key={member.id}
                className={UStyles.classNames(
                  styles.item,
                  value === member.id && styles.itemActive,
                )}
                onClick={() => handleSelect(member.id)}
              >
                {member.name}
              </div>
            ))}
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
}
